// 不知道放哪的可以放到这

import {IS_TEST} from './env'

// 接口超时时间
export const TIMEOUT = 5000
// 接口返回正常code
export const SUCCESS_CODE = 0
// 网络错误Toast信息
export const NETWORK_ERROR_TOAST = '网络异常，请检查网络设置并刷新页面'
// 分页基本大小
export const BASE_PAGE_SIZE = 10
// 全部请求的分页大小
export const MAX_PAGE_SIZE = 1000
// 分页当前页
export const BASE_CURRENT = 1
// 预取间隔
export const BASE_PRELOAD_INTERVAL = 1000

// html的head信息
export const CUSTOM_HEAD_TITLE = '图书内容'
export const CUSTOM_HEAD_THEME = '#ffffff'

// titlebar高度
export const TITLE_BAR_HEIGHT = 44
// 项目的basePath
export const BASE_PATH = '/book-content'
// 动画时长
export const ANI_TIMEOUT = 300
// 防抖时长
export const DEBOUNCE_TIMEOUT = 1000
// 视频倍速
export const RATE_OPTIONS: SN[] = [
    '2.0',
    '1.5',
    '1.2',
    '1.0',
    '0.8',
]
// 游戏化目录一个循环的数量
export const GAME_LOOP_COUNT = 9

export const PAY_SOURCE = IS_TEST ? 'sys207999911828919296z' : 'sys207999722660570112z'

